export class Step8 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step7';
    getspan11 = 'form.mapa_in.getspan11';
    getspan12 = 'form.mapa_in.getspan12';
    getspan13 = 'form.mapa_in.getspan13';
    getredressementjudiciaire = 'form.mapa_in.getredressementjudiciaire';
    getarticle2141 = 'form.mapa_in.getarticle2141';
    getarticlesl5212 = 'form.mapa_in.getarticlesl5212';
    getarticlesl1221l3243 = 'form.mapa_in.getarticlesl1221l3243';
    getarticlel3243 = 'form.mapa_in.getarticlel3243';
    getspan14 = 'form.mapa_in.getspan14';
    getchiffresaffaires = 'form.mapa_in.getchiffresaffaires';
    getrisquesprofessionels = 'form.mapa_in.getrisquesprofessionels';
    getbilans = 'form.mapa_in.getbilans';
    geteffectifs = 'form.mapa_in.geteffectifs';
    getlistefournituresservices = 'form.mapa_in.getlistefournituresservices';
    getlistetravaux = 'form.mapa_in.getlistetravaux';
    getindicationtitresoperateur = 'form.mapa_in.getindicationtitresoperateur';
    getindicationtitrescadres = 'form.mapa_in.getindicationtitrescadres';
    getequipementtechnique = 'form.mapa_in.getequipementtechnique';
    getequipementfournituresservices = 'form.mapa_in.getequipementfournituresservices';
    getqualificationsprofessionnelles = 'form.mapa_in.getqualificationsprofessionnelles';
    getprecisions = 'form.mapa_in.getprecisions';
    getconformitefournitures = 'form.mapa_in.getconformitefournitures';
    getdetailfournitures = 'form.mapa_in.getdetailfournitures';
    getdefensenationalitecandidat = 'form.mapa_in.getdefensenationalitecandidat';
    getdefensehabilitationsecret = 'form.mapa_in.getdefensehabilitationsecret';
    getautorisationspecifique = 'form.mapa_in.getautorisationspecifique';
    getdc1 = 'form.mapa_in.getdc1';
    getdc2 = 'form.mapa_in.getdc2';
    getdc3 = 'form.mapa_in.getdc3';
    getdc4 = 'form.mapa_in.getdc4';
    getdocumentsautreoperateur = 'form.mapa_in.getdocumentsautreoperateur';
    gettraductionfrancaisecandidat = 'form.mapa_in.gettraductionfrancaisecandidat';
    getspan15 = 'form.mapa_in.getspan15';
    getarticlesd8222 = 'form.mapa_in.getarticlesd8222';
    getattestationobligationsfiscales = 'form.mapa_in.getattestationobligationsfiscales';
    getcertificatpaysorigine = 'form.mapa_in.getcertificatpaysorigine';
    gettraductionfrancaiseattributaire = 'form.mapa_in.gettraductionfrancaiseattributaire';
    getjustificationautre = 'form.mapa_in.getjustificationautre_liste_avi_';
    getjustificationcomment = 'form.mapa_in.getjustificationcomment';
    getdocsconsultation = 'form.mapa_in.getdocsconsultation';

}
